import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { ZWfCatalogActionCreate } from "src/business/catalog/ZCatalog";
import { loadWorkflow } from "src/business/workflow/apiWorkflow";
import { getWorkflowDisplayName } from "src/business/workflow/getWorkflowDisplayName";
import { findFirstUserStep } from "src/business/workflow/workflowSteps";
import { ZWorkflow } from "src/business/workflow/ZWorkflow";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import { ZId } from "src/types";

import { CreateBtnLinkStd } from "./CreateBtnLinkStd";
import { getWorkflowCreateState } from "./getWorkflowCreateState";

const makeStore = (workflowId: string) =>
  makeAutoObservable({
    workflow: undefined as ZWorkflow | undefined,
    loading: !!workflowId,
    setWorkflow(workflow: ZWorkflow) {
      this.workflow = workflow;
    },
    setLoading(flag: boolean) {
      this.loading = flag;
    },
    get workflowTitle(): string {
      return this.workflow ? getWorkflowDisplayName(this.workflow) : "";
    },
    get noInitial(): boolean {
      return !!this.workflow && !findFirstUserStep(this.workflow.steps ?? []);
    },
    async load() {
      if (!workflowId) {
        this.setLoading(false);
        return;
      }

      this.setLoading(true);
      try {
        this.setWorkflow(await loadWorkflow(workflowId));
      } catch {
        // РП нужен для подсказки и проверки Initial. Без него кнопка доступна,
        // а ошибку 4.10 покажет страница новой рабочей версии
      } finally {
        this.setLoading(false);
      }
    },
  });

type PropsWorkflowCreateActionRenderer = ZWfCatalogActionCreate & {
  catalogId: ZId;
};

export const WorkflowCreateActionRenderer: React.FC<PropsWorkflowCreateActionRenderer> =
  observer(({ catalogId, disabled, workflowId }) => {
    const store = React.useMemo(() => makeStore(workflowId), [workflowId]);
    React.useEffect(() => {
      store.load();
    }, [store]);

    const state = getWorkflowCreateState({
      noRights: disabled || !workflowId,
      noInitial: store.noInitial,
      workflowTitle: store.loading ? "..." : store.workflowTitle,
    });

    return (
      <CreateBtnLinkStd
        text="Запись (РП)"
        disabled={state.disabled}
        tooltip={state.tooltip}
        url={makeUrl(PageUrl.newRecordWf, { id: catalogId, workflowId })}
      />
    );
  });
